export { MiddleYoungOnboardingWelcome } from "./MiddleYoungOnboardingWelcome";
